import { inject, PLATFORM_ID } from '@angular/core';
import { ResolveFn, Router } from '@angular/router';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { catchError, Observable, of, tap } from 'rxjs';
import { PageResolverResopnse } from '../types/page-resolver-response.type';
import { PageLayoutService } from '../services/page-resolver.service';
import { MetaService } from '../services/meta.service';
import { RESPONSE } from '../../../express.token';
import { isPlatformBrowser, isPlatformServer } from '@angular/common';
import { AdvancedSearchService } from '../../common/services/advanced-search.service';
import { GlobalService } from '../../common/services/global.service';
import { PageBuilderService } from '../services/page-builder.service';
import { cloneDeep } from 'lodash';
export const pageLayoutResolver: ResolveFn<PageResolverResopnse | null> = (
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
): Observable<PageResolverResopnse | null> => {
    const pageLayoutService = inject(PageLayoutService);
    const metaService = inject(MetaService);
    const res = inject(RESPONSE, { optional: true });
    const platformId = inject(PLATFORM_ID);
    const searchService = inject(AdvancedSearchService);
    const pageBuilderService = inject(PageBuilderService);
    const router = inject(Router);
    const globalService = inject(GlobalService);
    
    return pageLayoutService.resolvePageLayout(route).pipe(
        tap((response) => {
            searchService.searchResult.next(null);
            if (response?.pageDataResponse?.body?.data?.redirection) {
                const pageLayoutSettings = response.pageDataResponse.body.data;
                if (isPlatformBrowser(platformId)) {
                    let pageData = cloneDeep(response?.pageDataResponse) as any;
                    delete pageData.body.data.redirection;
                    pageBuilderService.pageData.next(pageData);
                    router.navigateByUrl(
                        `/${response.pageDataResponse.body.data.redirection.redirect_url}`,
                    );
                }
                if (isPlatformServer(platformId)) {
                    res?.redirect(
                        pageLayoutSettings.redirection.redirection_type,
                        `/${pageLayoutSettings?.redirection?.redirect_url}`,
                    );
                }
            }
            if ( response?.pageDataResponse?.body?.data?.page_type === 'not-found-page' ) {
                if (isPlatformServer(platformId)) {
                    res?.status(404);
                }
                globalService.isNotFoundPage.next(false);
            }
            metaService.updateMetaTags(response, route);
        }),
    );
};
